import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((app) => {
  const config = useRuntimeConfig()
  Sentry.init({
    enabled: config.public.environment !== 'development',
    app: app.vueApp,
    dsn: config.public.sentryDsn,
    release: config.public.appVersion,
    environment: config.public.environment,
    integrations: [
      Sentry.browserTracingIntegration({ router: app.$router }),
      Sentry.replayIntegration(),
    ],
    trackComponents: true,
    normalizeDepth: 8,
    ignoreErrors: ['ResizeObserver'],

    // Session events are not supported in glitchtip
    autoSessionTracking: false,

    // Set tracesSampleRate to 1.0 to capture 100%
    // Of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', config.public.baseUrl],

    // Capture Replay for 10% of all sessions,
    // Plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    /* Fixed floor (ES2023, ~early 2022), not a tracking match for the rolling window in the
       `browserslist` entry in package.json - a browser released between this floor and the
       actual window still passes. The floor is inherited from Vuetify's ripple directive (the
       only runtime findLast caller in the bundle), so a Vuetify baseline bump can move it. */
    beforeSend: (event) => (typeof Array.prototype.findLast === 'function' ? event : null),
  })

  return {
    provide: {
      sentry: Sentry,
    },
  }
})
